import date from '@/ddv2.library/date'
import google from '@/ddv2.library/utils/google'
import header from '@/ddv2.library/header'
import indexeddb from '@/ddv2.library/indexeddb'
// import message from '@/ddv2.library/messages'
import modals from '@/ddv2.library/modals'

import complements from '@/rahmen/complement'
import dolly from '@/rahmen/utils/dolly'
import filter from '@/rahmen/utils/filters'

import flowMixin from '@/mixins/flowMixins'

import { mapGetters } from 'vuex'

const DdCheckbox = () => import('@/components/DdCheckbox')
const DdCodeTextBox = () => import('@/components/DdCodeTextBox.vue')
const DdCodeTextBoxSwitching = () => import('@/components/DdCodeTextBoxSwitching')
const DdDefaultButton = () => import('@/components/DdDefaultButton')
const DdDateBox = () => import('@/components/DdDateBox')
const DdDropDown = () => import('@/components/DdDropDown')
const DdFooterButton = () => import('@/components/DdFooterButton')
const DdIconButton = () => import('@/components/DdIconButton')
const DdIconButtonWithTooltip = () => import('@/components/DdIconButtonWithTooltip')
const DdNumericBox = () => import('@/components/DdNumericBox.vue')
const DdSubHeader = () => import('@/components/DdSubHeader')
const DdTimeBoxSwitching = () => import('@/components/DdTimeBoxSwitching')
const DdTextBox = () => import('@/components/DdTextBox')
const DdTextBoxPlaceHolderFree = () => import('@/components/DdTextBoxPlaceHolderFree')
const DdTextBoxSwitching = () => import('@/components/DdTextBoxSwitching')
const ThKoteiKamotsuNoTextBox = () => import('@/components/ThKoteiKamotsuNoTextBox')

export default {
  name: 'SagyoMeisaiEdit',
  mixins: [flowMixin],
  components: {
    DdCheckbox,
    DdCodeTextBox,
    DdCodeTextBoxSwitching,
    DdDateBox,
    DdDefaultButton,
    DdDropDown,
    DdFooterButton,
    DdIconButton,
    DdIconButtonWithTooltip,
    DdNumericBox,
    DdSubHeader,
    DdTimeBoxSwitching,
    DdTextBox,
    DdTextBoxPlaceHolderFree,
    DdTextBoxSwitching,
    ThKoteiKamotsuNoTextBox
  },
  data: () => ({
    // ----------------------------------------------------------------------------------------------------
    // バインド変数定義
    // ----------------------------------------------------------------------------------------------------
    rec: {},

    // ----------------------------------------------------------------------------------------------------
    // 表示制御
    // ----------------------------------------------------------------------------------------------------
    baseYmd: '',
    mapData: [],

    modeKengen: 2, // 0:読み取り専用,1:削除不可,2:フルアクセス
    modeOfEdit: 0,

    hinmeiSwitch: false,
    hatsuchiSwitch: false,
    hatsuchiHmsSwitch: false,
    chakuchiSwitch: false,
    chakuchiHmsSwitch: false,
    expandKeiyuchi: false,

    // ----------------------------------------------------------------------------------------------------
    // オートコンプリート定義
    // ----------------------------------------------------------------------------------------------------
    mstEigyoshoHeaders: header.mstEigyoshoHeaders,
    mstTorihikisakiHeaders: header.mstTorihikisakiHeaders,
    mstJininHeaders: header.mstJininHeaders,
    mstSharyoHeaders: header.vwCMstSharyoHeaders,
    mstHinmeiHeaders: header.mstHinmeiHeaders,
    mstHacchakuchiHeaders: header.mstHacchakuchiHeaders

  }),
  computed: {
    ...mapGetters({
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      eigyoshoList: 'DDMasters/mstEigyosho',
      hinmeiList: 'DDMasters/mstHinmei',
      hacchakuchiList: 'DDMasters/mstHacchakuchi',
      jininList: 'DDMasters/vwCMstEigyoshoJininList',
      sharyoList: 'DDMasters/vwCMstSharyo',
      kubunList: 'DDMasters/msysKubun',
      shubetsuList: 'DDMasters/mstShubetsu',
      currentKaishaCode: 'users/currentKaishaCode',
      usersEigyoshoCd: 'users/eigyoshoCd'
    }),
    // ----------------------------------------------------------------------------------------------------
    // マスタヘルプフィルタ
    // ----------------------------------------------------------------------------------------------------
    // 営業所
    filteredEigyoshoList () {
      const target = filter.dateFormatter(new Date())
      return this.eigyoshoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.eigyoshoKbn === '01'
      })
    },
    // 得意先
    filteredMstTokuisakiList () {
      const target = filter.dateFormatter(new Date())
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter((t) => {
        return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target && t.tokuisakiFlg === true
      })
    },
    // 品名
    filteredHinmeiList () {
      const target = filter.dateFormatter(new Date())
      return this.hinmeiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      })
    },
    // 発着地
    filteredHacchakuchiList () {
      const self = this
      return self.hacchakuchiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return self.hacchakuchiFilter(elem)
      })
    },
    filteredHacchakuchiListLite () {
      if (!this.expandKeiyuchi) {
        return []
      }

      const self = this
      return self.hacchakuchiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return self.hacchakuchiFilter(elem)
      })
    },

    // ----------------------------------------------------------------------------------------------------
    // 区分種別フィルタ
    // ----------------------------------------------------------------------------------------------------
    // 往復種別
    filteredOhfukuShubetsList () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'SBT006')
    },
    // キャンセル理由種別
    filteredsSagyoCancelRiyuShubetsList () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'SBT029')
    },
    // 単位区分フィルター
    filteredUnitKbnList () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'SVI001')
    },

    // ----------------------------------------------------------------------------------------------------
    // 金額計算
    // ----------------------------------------------------------------------------------------------------
    calcUriageKingakuAmount () {
      let amount = 0

      if (this.hikazeiKingakuAmount > 0 || this.unchinAddWarimashiKingakuAmout > 0) {
        amount = parseInt(this.hikazeiKingakuAmount, 10) + parseInt(this.unchinAddWarimashiKingakuAmout, 10)
      }

      return amount
    },
    unchinKingakuAmount () {
      // 配送明細が存在しない場合
      if (this.rec === {}) { return 0 }

      let kihonUnchin = this.rec.kihonUnchin
      let userKingakuKazei1 = this.rec.userKingakuKazei1
      let userKingakuKazei3 = this.rec.userKingakuKazei3
      let userKingakuKazei4 = this.rec.userKingakuKazei4

      if (kihonUnchin === undefined || kihonUnchin === '' || kihonUnchin === null) { kihonUnchin = '0' }
      if (userKingakuKazei1 === undefined || userKingakuKazei1 === '' || userKingakuKazei1 === null) { userKingakuKazei1 = '0' }
      if (userKingakuKazei3 === undefined || userKingakuKazei3 === '' || userKingakuKazei3 === null) { userKingakuKazei3 = '0' }
      if (userKingakuKazei4 === undefined || userKingakuKazei4 === '' || userKingakuKazei4 === null) { userKingakuKazei4 = '0' }

      let amount = 0

      amount = parseInt(kihonUnchin, 10) + parseInt(userKingakuKazei1, 10) + parseInt(userKingakuKazei3, 10) + parseInt(userKingakuKazei4, 10)

      return amount
    },
    hikazeiKingakuAmount () {
      // 配送明細が存在しない場合
      if (this.rec === {}) { return 0 }

      let hiwayPrice = this.rec.hiwayPrice
      let userKingakuHikazei1 = this.rec.userKingakuHikazei1
      let userKingakuHikazei2 = this.rec.userKingakuHikazei2

      if (hiwayPrice === undefined || hiwayPrice === '' || hiwayPrice === null) { hiwayPrice = '0' }
      if (userKingakuHikazei1 === undefined || userKingakuHikazei1 === '' || userKingakuHikazei1 === null) { userKingakuHikazei1 = '0' }
      if (userKingakuHikazei2 === undefined || userKingakuHikazei2 === '' || userKingakuHikazei2 === null) { userKingakuHikazei2 = '0' }

      let amount = 0

      amount = parseInt(hiwayPrice, 10) + parseInt(userKingakuHikazei1, 10) + parseInt(userKingakuHikazei2, 10)

      return amount
    },
    warimashiKingakuAmount () {
      // 配送明細が存在しない場合
      if (this.rec === {}) { return 0 }

      let jikanWarimashiKingaku = this.rec.jikanWarimashiKingaku
      let kyoriWarimashiKingaku = this.rec.kyoriWarimashiKingaku
      let userKingakuKazei2 = this.rec.userKingakuKazei2

      if (jikanWarimashiKingaku === undefined || jikanWarimashiKingaku === '' || jikanWarimashiKingaku === null) { jikanWarimashiKingaku = '0' }
      if (kyoriWarimashiKingaku === undefined || kyoriWarimashiKingaku === '' || kyoriWarimashiKingaku === null) { kyoriWarimashiKingaku = '0' }
      if (userKingakuKazei2 === undefined || userKingakuKazei2 === '' || userKingakuKazei2 === null) { userKingakuKazei2 = '0' }

      let amount = 0

      amount = parseInt(jikanWarimashiKingaku, 10) + parseInt(kyoriWarimashiKingaku, 10) + parseInt(userKingakuKazei2, 10)

      return amount
    },
    unchinAddWarimashiKingakuAmout () {
      let amount = 0

      amount = parseInt(this.unchinKingakuAmount, 10) + parseInt(this.warimashiKingakuAmount, 10)

      return amount
    },

    // ----------------------------------------------------------------------------------------------------
    // 項目制御
    // ----------------------------------------------------------------------------------------------------
    isShoukaiMode () {
      return this.modeOfEdit === 1
    },
    isCancelButtonDisplay () {
      if (this.modeKengen === 0 || this.modeOfEdit === 1) {
        return false
      }
      return true
    },
    isDeleteButtonDisplay () {
      if (this.modeKengen === 2 && this.modeOfEdit === 2) {
        return true
      }
      return false
    },
    isCopyButtonDisplay () {
      if (this.modeKengen !== 0 && this.modeOfEdit === 2) {
        return true
      }
      return false
    },
    isSaveButtonDisp () {
      if (this.modeKengen !== 0 && this.modeOfEdit !== 1) {
        return true
      }
      return false
    },
    isReadOnlyBase () {
      if (this.modeKengen === 0 || this.modeOfEdit === 1) {
        return true
      }
      return false
    },
    isMapUsable () {
      if ((this.rec.hatsuchiId) ||
          (this.rec.keiyuchiId1) ||
          (this.rec.keiyuchiId2) ||
          (this.rec.keiyuchiId3) ||
          (this.rec.keiyuchiId4) ||
          (this.rec.keiyuchiId5) ||
          (this.rec.chakuchiId)) {
        return true
      }
      return false
    }
  },

  created () {
    this.id = this.$route.params.id
    this.id = (this.id === '0') ? 0 : this.id
  },

  mounted () {
    this.initialize()
  },

  methods: {
    getCloneTargetMethod: function () {
      return {
        rec: this.rec
      }
    },
    beforeRouteLeaveByMenu: function (next) {
      const opt = {
        nextCallback: next
      }

      this.preventTransition(opt)
    },

    // ----------------------------------------------------------------------------------------------------
    // データ抽出処理
    // ----------------------------------------------------------------------------------------------------
    fetchData: function () {
      return new Promise((resolve) => {
        console.log(this.id)
        // /* eslint no-debugger: "warn" */
        // debugger

        this.HttpClient
          .get(`/api/v1/VwCD2plmd0030/Find?id=${this.id}`)
          .then((data) => {
            if (data.payload) {
              const x = data.payload

              if (x.sagyoYoteiYmd) {
                x.sagyoYoteiYmd = filter.dateFormatter(x.sagyoYoteiYmd)
              }
              if (x.hatsuchiYmd) {
                x.hatsuchiYmd = filter.dateFormatter(x.hatsuchiYmd)
              }
              if (x.hatsuchiHms) {
                x.hatsuchiHms = complements.parseTime(x.hatsuchiHms, false).substr(0, 5)
              }
              if (x.chakuchiYmd) {
                x.chakuchiYmd = filter.dateFormatter(x.chakuchiYmd)
              }
              if (x.chakuchiHms) {
                x.chakuchiHms = complements.parseTime(x.chakuchiHms, false).substr(0, 5)
              }
              if (x.yoteiSagyoJikan) {
                x.yoteiSagyoJikan = filter.minToTimeFormatter(x.yoteiSagyoJikan)
              }
              if (x.warimashiTaishoJikan) {
                x.warimashiTaishoJikan = filter.minToTimeFormatter(x.warimashiTaishoJikan)
              }
              if (!x.mstHinmeiId && x.hinmeiBiko) { this.hinmeiSwitch = true }

              if (!x.hatsuchiId && x.hatsuchiBiko) { this.hatsuchiSwitch = true }

              if (!x.hatsuchiHms && x.hatsuchiHmsBiko) { this.hatsuchiHmsSwitch = true }

              if (!x.chakuchiId && x.chakuchiBiko) { this.chakuchiSwitch = true }

              if (!x.chakuchiHms && x.chakuchiHmsBiko) { this.chakuchiHmsSwitch = true }

              this.expandKeiyuchi = Boolean(x.keiyuchiId2 || x.keiyuchiId2Biko || x.keiyuchiId3 || x.keiyuchiId3Biko || x.keiyuchiId4 || x.keiyuchiId4Biko || x.keiyuchiId5 || x.keiyuchiId5Biko)

              this.rec = x

              // 基準日設定
              this.baseYmd = filter.dateFormatter(this.rec.sagyoYoteiYmd)

              // クローン情報設定
              this.cloneData = dolly.clone(this.getCloneTargetMethod())
            }
          })
        resolve()
      })
    },

    // ----------------------------------------------------------------------------------------------------
    // 初期化処理
    // ----------------------------------------------------------------------------------------------------
    initialize () {
      const self = this
      const option = {
        loadMasters: [
          'msttorihikisaki',
          'msteigyosho',
          'msthinmei',
          'msthacchakuchi',
          'vwcmsteigyoshojininlist',
          'vwcmstsharyo',
          'msyskubun',
          'mstshubetsu'
        ],
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            self.initBindVariables()
            resolve()
          })
        },
        savedInputRestorePromise: function () {
          return new Promise((resolve) => {
            resolve()
          })
        },
        existsIdMethod: function () {
          return self.id !== 0
        },
        requestApiPromise: this.fetchData,
        settingButtonStatePromise: (kengen) => {
          return new Promise((resolve) => {
            // 権限制御
            if (kengen.kengenKbn === '10') {
              self.modeKengen = 0 // 読取モード
            } else if (kengen.kengenKbn === '20') {
              self.modeKengen = 1 // 削除不可モード
            } else {
              self.modeKengen = 2 // フルアクセス
            }

            // 画面モード設定
            if (self.id === 0) {
              self.modeOfEdit = 0 // 新規モード
            } else if (this.modeKengen === 0) {
              self.modeOfEdit = 1 // 照会モード
            } else {
              self.modeOfEdit = 2 // 更新モード
            }

            this.$nextTick(() => {
              document.getElementById('heavy-element').style.display = ''
            })

            resolve()
          })
        }
      }
      this.initializeForRegister(option)
    },

    // ----------------------------------------------------------------------------------------------------
    // 戻るボタン押下
    // ----------------------------------------------------------------------------------------------------
    onReturnButtonClick: function (e) {
      console.log('onReturnButtonClick', e)
      const self = this
      const opt = {
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        }
      }

      this.transitionBack(opt)
    },

    // ----------------------------------------------------------------------------------------------------
    // キャンセルボタン押下
    // ----------------------------------------------------------------------------------------------------
    onCancelButtonClick: function (e) {
      console.log('onCancelButtonClick', e)
      const self = this
      const opt = {
        restoreInputsPromise: function (data) {
          return new Promise(resolve => {
            self.rec = self.cloneData.rec
            self.hatsuchiSwitch = self.cloneData.hatsuchiSwitch
            self.chakuchiSwitch = self.cloneData.chakuchiSwitch
            self.hatsuchiHmsSwitch = self.cloneData.hatsuchiHmsSwitch
            self.chakuchiHmsSwitch = self.cloneData.chakuchiHmsSwitch
            resolve()
          })
        }
      }

      this.cancelInputs(opt)
    },

    // ----------------------------------------------------------------------------------------------------
    // 削除ボタン押下
    // ----------------------------------------------------------------------------------------------------
    onDeleteButtonClick: function (e) {
      const self = this
      const opt = {
        deleteRequestPromise: function () {
          return new Promise(resolve => {
            self.convertToDBType()
            self.HttpClient.post('/api/v1/VwCD2plmd0030/DeleteSagyoInfo', self.rec).then(data => {
              resolve(data)
            })
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        }
      }
      this.delete(opt)
    },
    deleteValidate: function () {
      if (this.rec.trJuchuKihonId || this.rec.trHacchuKihonId || this.rec.trSagyoJissekiId || this.rec.trSagyoKeikakuMeisaiId) {
        this.setInvalidSummaryMessage('PLME0005')
        return false
      }
      return true
    },

    // ----------------------------------------------------------------------------------------------------
    // 複写ボタン押下
    // ----------------------------------------------------------------------------------------------------
    onCopyButtonClick: function (e) {
      const p = modals.showConfirm
      p('COMQ0004').then((ok) => {
        if (ok === false || ok === undefined) { return }
        this.Effects.loadStart()
        const x = this.rec
        x.id = -1
        x.trSagyoHinmokuId = null
        x.trJuchuKihonId = null
        x.trHacchuKihonId = null
        x.trSagyoJissekiId = null
        x.trSagyoKeikakuMeisaiId = null
        x.sagyoMeisaiNo = null

        this.rec = x
        this.Effects.loadComplete()
      })
    },

    // ----------------------------------------------------------------------------------------------------
    // 保存ボタン押下
    // ----------------------------------------------------------------------------------------------------
    onSaveButtonClick: function (e) {
      const self = this
      const opt = {
        registerRequestPromise: self.registerPromise,
        registerResponsePromise: (data) => {
          return new Promise(resolve => {
            self.id = data.payload.id
            resolve()
          })
        },
        getIdMethod: () => {
          return self.id
        },
        continuousInputInitializePromise: (id) => {
          return new Promise(resolve => {
            this.id = id
            this.transition(1, { id: id }, this.initialize)
            resolve()
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        },
        isUpdateModeMethod: function () {
          return self.id !== 0
        },
        getSavedInputMethod: function () {
          return {}
        }
      }
      this.register(opt)
    },
    registerPromise: function () {
      this.convertToDBType()
      const f = this.HttpClient.post('/api/v1/VwCD2plmd0030/CreateSagyoInfo', this.rec)
      return f
    },
    registerValidate: function () {
      return true
    },
    convertToDBType: function () {
      if (this.rec.yoteiSagyoJikan) {
        this.rec.yoteiSagyoJikan = filter.timeToMinFormatter(this.rec.yoteiSagyoJikan)
      }
      if (this.rec.warimashiTaishoJikan) {
        this.rec.warimashiTaishoJikan = filter.timeToMinFormatter(this.rec.warimashiTaishoJikan)
      }
    },

    // ----------------------------------------------------------------------------------------------------
    // 初期値設定
    // ----------------------------------------------------------------------------------------------------
    onMapViewClick: function (target) {
      // 初期化
      this.mapData = []
      // 発地設定
      if ((this.rec.hatsuchiId) && this.rec.hatsuchiId !== '' && this.rec.hatsuchiId !== null) {
        const hatsuchi = {
          id: this.rec.hatsuchiId,
          ymdhms: (this.rec.hatsuchiYmd !== undefined && this.rec.hatsuchiYmd !== null && this.rec.hatsuchiYmd !== '' ? this.rec.hatsuchiYmd : '2999/12/31') + (this.rec.hatsuchiHms !== undefined && this.rec.hatsuchiHms !== null && this.rec.hatsuchiHms !== '' ? this.rec.hatsuchiHms : '00:00')
        }

        if (this.mapData.length > 0) {
          this.mapData.push(hatsuchi)
        } else {
          this.mapData = [hatsuchi]
        }
      }
      // 経由地１ ※日時は発地と同値を設定
      if ((this.rec.keiyuchiId1) && this.rec.keiyuchiId1 !== '' && this.rec.keiyuchiId1 !== null) {
        const keiyuchi = {
          id: this.rec.keiyuchiId1,
          ymdhms: (this.rec.hatsuchiYmd !== undefined && this.rec.hatsuchiYmd !== null && this.rec.hatsuchiYmd !== '' ? this.rec.hatsuchiYmd : '2999/12/31') + (this.rec.hatsuchiHms !== undefined && this.rec.hatsuchiHms !== null && this.rec.hatsuchiHms !== '' ? this.rec.hatsuchiHms : '00:00')
        }

        if (this.mapData.length > 0) {
          this.mapData.push(keiyuchi)
        } else {
          this.mapData = [keiyuchi]
        }
      }
      // 経由地２ ※日時は発地と同値を設定
      if ((this.rec.keiyuchiId2) && this.rec.keiyuchiId2 !== '' && this.rec.keiyuchiId2 !== null) {
        const keiyuchi = {
          id: this.rec.keiyuchiId2,
          ymdhms: (this.rec.hatsuchiYmd !== undefined && this.rec.hatsuchiYmd !== null && this.rec.hatsuchiYmd !== '' ? this.rec.hatsuchiYmd : '2999/12/31') + (this.rec.hatsuchiHms !== undefined && this.rec.hatsuchiHms !== null && this.rec.hatsuchiHms !== '' ? this.rec.hatsuchiHms : '00:00')
        }

        if (this.mapData.length > 0) {
          this.mapData.push(keiyuchi)
        } else {
          this.mapData = [keiyuchi]
        }
      }
      // 経由地３ ※日時は発地と同値を設定
      if ((this.rec.keiyuchiId3) && this.rec.keiyuchiId3 !== '' && this.rec.keiyuchiId3 !== null) {
        const keiyuchi = {
          id: this.rec.keiyuchiId3,
          ymdhms: (this.rec.hatsuchiYmd !== undefined && this.rec.hatsuchiYmd !== null && this.rec.hatsuchiYmd !== '' ? this.rec.hatsuchiYmd : '2999/12/31') + (this.rec.hatsuchiHms !== undefined && this.rec.hatsuchiHms !== null && this.rec.hatsuchiHms !== '' ? this.rec.hatsuchiHms : '00:00')
        }

        if (this.mapData.length > 0) {
          this.mapData.push(keiyuchi)
        } else {
          this.mapData = [keiyuchi]
        }
      }
      // 経由地４ ※日時は発地と同値を設定
      if ((this.rec.keiyuchiId4) && this.rec.keiyuchiId4 !== '' && this.rec.keiyuchiId4 !== null) {
        const keiyuchi = {
          id: this.rec.keiyuchiId4,
          ymdhms: (this.rec.hatsuchiYmd !== undefined && this.rec.hatsuchiYmd !== null && this.rec.hatsuchiYmd !== '' ? this.rec.hatsuchiYmd : '2999/12/31') + (this.rec.hatsuchiHms !== undefined && this.rec.hatsuchiHms !== null && this.rec.hatsuchiHms !== '' ? this.rec.hatsuchiHms : '00:00')
        }

        if (this.mapData.length > 0) {
          this.mapData.push(keiyuchi)
        } else {
          this.mapData = [keiyuchi]
        }
      }
      // 経由地５ ※日時は発地と同値を設定
      if ((this.rec.keiyuchiId5) && this.rec.keiyuchiId5 !== '' && this.rec.keiyuchiId5 !== null) {
        const keiyuchi = {
          id: this.rec.keiyuchiId5,
          ymdhms: (this.rec.hatsuchiYmd !== undefined && this.rec.hatsuchiYmd !== null && this.rec.hatsuchiYmd !== '' ? this.rec.hatsuchiYmd : '2999/12/31') + (this.rec.hatsuchiHms !== undefined && this.rec.hatsuchiHms !== null && this.rec.hatsuchiHms !== '' ? this.rec.hatsuchiHms : '00:00')
        }

        if (this.mapData.length > 0) {
          this.mapData.push(keiyuchi)
        } else {
          this.mapData = [keiyuchi]
        }
      }
      // 着地設定
      if ((this.rec.chakuchiId) && this.rec.chakuchiId !== '' && this.rec.chakuchiId !== null) {
        const chakuchi = {
          id: this.rec.chakuchiId,
          ymdhms: (this.rec.chakuchiYmd !== undefined && this.rec.chakuchiYmd !== null && this.rec.chakuchiYmd !== '' ? this.rec.chakuchiYmd : '2999/12/31') + (this.rec.chakuchiHms !== undefined && this.rec.chakuchiHms !== null && this.rec.chakuchiHms !== '' ? this.rec.chakuchiHms : '00:00')
        }

        if (this.mapData.length > 0) {
          this.mapData.push(chakuchi)
        } else {
          this.mapData = [chakuchi]
        }
      }

      const url = 'https://www.google.com/maps/dir' + google.getAddressStrings(this.hacchakuchiList, this.mapData)
      window.open(url, '_blank')
    },

    // ----------------------------------------------------------------------------------------------------
    // 初期値設定
    // ----------------------------------------------------------------------------------------------------
    initBindVariables: function () {
      this.baseYmd = date.getCurrentDate()
      // 入力項目
      this.$refs.sagyoYoteiYmd.onCalendarInput(this.baseYmd)
      this.rec.sagyoEigyoshoId = this.eigyoshoList.length > 0 ? indexeddb.getRecordByCd(this.currentKaishaCode, this.eigyoshoList, 'eigyoshoCd', this.usersEigyoshoCd, this.baseYmd).id : null

      // 入力制御
      this.modeKengen = 0
      this.modeOfEdit = 0
      this.hinmeiSwitch = false
      this.hatsuchiSwitch = false
      this.hatsuchiHmsSwitch = false
      this.chakuchiSwitch = false
      this.chakuchiHmsSwitch = false
      this.expandKeiyuchi = false
    },

    // ----------------------------------------------------------------------------------------------------
    // 項目切替
    // ----------------------------------------------------------------------------------------------------
    onSwitchingHinmeiCodeToBiko (f) {
      this.hinmeiSwitch = f
    },
    onSwitchingHatsuchiCodeToBiko (f) {
      this.hatsuchiSwitch = f
    },
    onSwitchingHatsuchiHmsToBiko (f) {
      this.hatsuchiHmsSwitch = f
    },
    onSwitchingChakuchiCodeToBiko (f) {
      this.chakuchiSwitch = f
    },
    onSwitchingChakuchiHmsToBiko (f) {
      this.chakuchiHmsSwitch = f
    },
    onExpandKeiyuchi: function () {
      this.expandKeiyuchi = !this.expandKeiyuchi
    },

    // ----------------------------------------------------------------------------------------------------
    // フィルタ補助
    // ----------------------------------------------------------------------------------------------------
    hacchakuchiFilter (elem) {
      const self = this
      const target = filter.dateFormatter(new Date())
      return (elem.tekiyoStartYmdDisp <= target) &&
            (elem.tekiyoEndYmdDisp >= target) &&
            (!self.selectNinushiCd || (elem.torihikisakiCd === self.selectNinushiCd || elem.torihikisakiCd === null))
    },

    // ----------------------------------------------------------------------------------------------------
    // 時間計算補助
    // ----------------------------------------------------------------------------------------------------
    calcTime: function (p) {
      var result = ''
      if (p.indexOf(':') !== -1) {
        p = p.replace(':', '')
      }
      if (p.length < 3) {
        result = filter.minToTimeFormatter(parseInt(p, 10))
      } else {
        var min = parseInt(p.slice(0, p.length - 2), 10) * 60 + parseInt(p.slice(-2), 10)
        result = filter.minToTimeFormatter(min)
      }
      return result
    },

    // ----------------------------------------------------------------------------------------------------
    // 請求補助
    // ----------------------------------------------------------------------------------------------------
    inputYoteiSagyoJikan: function () {
      if (this.rec.yoteiSagyoJikan) {
        this.$set(this.rec, 'yoteiSagyoJikan', this.calcTime(this.rec.yoteiSagyoJikan))
      }
    },

    // ----------------------------------------------------------------------------------------------------
    // 割増補助
    // ----------------------------------------------------------------------------------------------------
    inputWarimashiTaishoJikan: function () {
      if (this.rec.warimashiTaishoJikan) {
        this.$set(this.rec, 'warimashiTaishoJikan', this.calcTime(this.rec.warimashiTaishoJikan))
      }
    }
  }
}
